import React from 'react'
import {Typography, Box,} from "@mui/material";


export default function MemberCard({name, role, img}) {
  return (
    <Box >
        <img src={img} alt={name} style={{width:"250px", borderRadius: 5 }}/>
      <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700 }}
        >
            {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
            {role}
        </Typography>
    </Box>
  )
}
